function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("linearGradient", {
  id: "9bzxgaqe0a",
  x1: "82.64%",
  x2: "59.951%",
  y1: "32.237%",
  y2: "55.215%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#31ABEC"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#1582D5"
})), React.createElement("linearGradient", {
  id: "3utdjfintb",
  x1: "2.217%",
  x2: "94.283%",
  y1: "49.552%",
  y2: "50.477%"
}, React.createElement("stop", {
  offset: "4.2%",
  stopColor: "#076DB4"
}), React.createElement("stop", {
  offset: "85%",
  stopColor: "#0461AF"
})), React.createElement("linearGradient", {
  id: "q08f3giq7c",
  x1: "50.134%",
  x2: "35.196%",
  y1: "49.475%",
  y2: "64.143%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#33ACEE"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#1B8EDF"
})), React.createElement("linearGradient", {
  id: "hz48vs65rd",
  x1: "2.65%",
  x2: "97.05%",
  y1: "2.65%",
  y2: "97.05%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#1784D8"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#0864C5"
})));

var _ref3 =
/*#__PURE__*/
React.createElement("g", {
  fill: "none"
}, React.createElement("path", {
  fill: "#103262",
  d: "M25.36 11.055l-4.29-2.5v7.305h4.76V11.87c0-.336-.179-.647-.47-.816z"
}), React.createElement("path", {
  fill: "#0084D7",
  d: "M6.3 2.52L12.6 2.52 12.6 8.19 6.3 8.19z"
}), React.createElement("path", {
  fill: "#33AFEC",
  d: "M12.6 2.52L18.9 2.52 18.9 8.19 12.6 8.19z"
}), React.createElement("path", {
  fill: "#54DAFF",
  d: "M18.9 2.52L25.2 2.52 25.2 8.19 18.9 8.19z"
}), React.createElement("path", {
  fill: "#027AD4",
  d: "M12.6 8.19L18.9 8.19 18.9 13.86 12.6 13.86z"
}), React.createElement("path", {
  fill: "#0553A4",
  d: "M12.6 13.86L18.9 13.86 18.9 19.53 12.6 19.53z"
}), React.createElement("path", {
  fill: "#25A2E5",
  d: "M18.9 8.19L25.2 8.19 25.2 13.86 18.9 13.86z"
}), React.createElement("path", {
  fill: "#0262B8",
  d: "M18.9 13.86L25.2 13.86 25.2 19.53 18.9 19.53z"
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 11.49 16.374 16.53 6.3 11.49z",
  opacity: 0.019
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 11.64 16.374 16.68 6.3 11.64z",
  opacity: 0.038
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 11.79 16.374 16.83 6.3 11.79z",
  opacity: 0.057
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 11.94 16.374 16.98 6.3 11.94z",
  opacity: 0.076
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 12.09 16.374 17.13 6.3 12.09z",
  opacity: 0.095
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 12.24 16.374 17.28 6.3 12.24z",
  opacity: 0.114
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 12.39 16.374 17.43 6.3 12.39z",
  opacity: 0.133
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 12.54 16.374 17.58 6.3 12.54z",
  opacity: 0.152
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 12.69 16.374 17.73 6.3 12.69z",
  opacity: 0.171
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 12.84 16.374 17.88 6.3 12.84z",
  opacity: 0.191
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 12.99 16.374 18.03 6.3 12.99z",
  opacity: 0.209
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 13.14 16.374 18.18 6.3 13.14z",
  opacity: 0.229
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 13.29 16.374 18.33 6.3 13.29z",
  opacity: 0.248
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 13.44 16.374 18.48 6.3 13.44z",
  opacity: 0.267
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 13.59 16.374 18.63 6.3 13.59z",
  opacity: 0.286
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 13.74 16.374 18.78 6.3 13.74z",
  opacity: 0.305
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 13.89 16.374 18.93 6.3 13.89z",
  opacity: 0.324
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 14.04 16.374 19.08 6.3 14.04z",
  opacity: 0.343
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 14.19 16.374 19.23 6.3 14.19z",
  opacity: 0.362
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 14.34 16.374 19.38 6.3 14.34z",
  opacity: 0.381
}), React.createElement("path", {
  fill: "#000",
  d: "M6.3 19.53L25.2 19.53 25.2 14.49 16.374 19.53 6.3 14.49z",
  opacity: 0.4
}), React.createElement("path", {
  fill: "url(#9bzxgaqe0a)",
  d: "M7.838 22.68h16.735c.695 0 1.259-.56 1.26-1.256.001-2.848-.003-9.553-.003-9.553s-.004.14-1.103.764c-1.099.623-17.328 9.772-17.328 9.772s.147.273.439.273z"
}), React.createElement("path", {
  fill: "url(#3utdjfintb)",
  d: "M25.2 2.52H6.3V1.26C6.3.564 6.864 0 7.56 0h16.38c.696 0 1.26.564 1.26 1.26v1.26z"
}), React.createElement("path", {
  fill: "url(#q08f3giq7c)",
  d: "M6.3 11.97v9.45c0 .696.564 1.26 1.26 1.26H24.573c.29 0 .556-.102.769-.268L6.3 11.97z"
}), React.createElement("path", {
  fill: "#000",
  d: "M11.541 4.41H6.3v15.12h5.241c1.28 0 2.319-1.038 2.319-2.319V6.729c0-1.28-1.038-2.319-2.319-2.319z",
  opacity: 0.05
}), React.createElement("path", {
  fill: "#000",
  d: "M11.474 18.9H6.3V4.62h5.174c1.086 0 1.966.88 1.966 1.966v10.348c0 1.086-.88 1.966-1.966 1.966z",
  opacity: 0.07
}), React.createElement("path", {
  fill: "#000",
  d: "M11.407 18.27H6.3V4.83h5.107c.89 0 1.613.722 1.613 1.613v10.214c0 .891-.722 1.613-1.613 1.613z",
  opacity: 0.09
}), React.createElement("path", {
  fill: "url(#hz48vs65rd)",
  d: "M11.34 17.64H1.26c-.696 0-1.26-.564-1.26-1.26V6.3c0-.696.564-1.26 1.26-1.26h10.08c.696 0 1.26.564 1.26 1.26v10.08c0 .696-.564 1.26-1.26 1.26z"
}), React.createElement("path", {
  fill: "#FFF",
  d: "M6.3 7.995c-1.96 0-3.14 1.498-3.14 3.345 0 1.847 1.176 3.345 3.14 3.345 1.965 0 3.14-1.498 3.14-3.344 0-1.848-1.18-3.346-3.14-3.346zm0 5.56c-1.112 0-1.777-.99-1.777-2.214S5.191 9.126 6.3 9.126s1.777.992 1.777 2.215c0 1.222-.666 2.215-1.777 2.215z"
}));

var SvgIconOutlook = function SvgIconOutlook(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: 26,
    height: 23,
    viewBox: "0 0 26 23",
    ref: svgRef
  }, props), _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgIconOutlook, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/icon-outlook.d3466b93.svg";
export { ForwardRef as ReactComponent };